import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { toast } from "sonner";

/**
 * Shared hook + primitives used by both SiteSettingsAdmin and FinanceSettingsAdmin.
 * PUT /admin/settings merges via $set, so each page saves only its own sub-object.
 */
export const useSiteSettings = () => {
  const [settings, setSettings] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/content").then(({ data }) => setSettings(data.settings || {}));
  }, []);

  const save = async () => {
    if (!settings) return;
    setSaving(true);
    try {
      await api.put("/admin/settings", settings);
      toast.success("Paramètres enregistrés");
    } catch {
      toast.error("Erreur lors de l'enregistrement");
    } finally { setSaving(false); }
  };

  return { settings, setSettings, save, saving };
};

export const Field = ({ settings, setSettings, fieldKey, label, type = "text", placeholder, full }) => (
  <div className={full ? "md:col-span-2" : ""}>
    <label className="block text-xs uppercase tracking-widest text-stone-500 mb-1.5">{label}</label>
    {type === "textarea" ? (
      <textarea
        value={settings[fieldKey] || ""}
        onChange={(e) => setSettings({ ...settings, [fieldKey]: e.target.value })}
        rows={3}
        className="w-full bg-stone-50 border border-stone-200 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blush"
        placeholder={placeholder}
      />
    ) : (
      <input
        type={type}
        value={settings[fieldKey] || ""}
        onChange={(e) => setSettings({ ...settings, [fieldKey]: e.target.value })}
        className="w-full bg-stone-50 border border-stone-200 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blush"
        placeholder={placeholder}
      />
    )}
  </div>
);

export const SectionTitle = ({ title, subtitle }) => (
  <div className="md:col-span-2 mt-2 pt-4 border-t border-stone-200">
    <h3 className="font-serif-display text-lg text-stone-800 mb-1">{title}</h3>
    {subtitle && <p className="text-stone-500 text-sm mb-3">{subtitle}</p>}
  </div>
);
